import { cn } from "../../lib/utils";
import { LogoCloud } from "./logo-cloud-3";

export default function BrandPartnersDemo() {
  return (
    <div className="w-full bg-white py-16">
      <div
        aria-hidden="true"
        className={cn(
          "-z-10 -top-1/2 -translate-x-1/2 pointer-events-none absolute left-1/2 h-[120vmin] w-[120vmin] rounded-b-full",
          "bg-[radial-gradient(ellipse_at_center,rgba(30,58,138,0.1),transparent_50%)]",
          "blur-[30px]"
        )}
      />
      <section className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <h2 className="mb-8 text-center font-bold text-blue-900 text-2xl tracking-tight md:text-4xl">
          <span className="text-gray-600">Partenaires de Confiance</span>
          <br />
          <span className="font-bold">Marques Reconnues</span>
        </h2>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          Nous travaillons avec les meilleures marques du secteur pour vous garantir 
          des équipements et services de qualité supérieure.
        </p>
        <div className="mx-auto my-8 h-px max-w-sm bg-gray-200 [mask-image:linear-gradient(to_right,transparent,black,transparent)]" />
        <LogoCloud logos={logos} />
        <div className="mt-8 h-px bg-gray-200 [mask-image:linear-gradient(to_right,transparent,black,transparent)]" />
      </section>
    </div>
  );
}

const logos = [
  {
    src: "/1.png",
    alt: "Partenaire 1",
  },
  {
    src: "/2.png", 
    alt: "Partenaire 2",
  },
  {
    src: "/3.png",
    alt: "Partenaire 3", 
  },
  {
    src: "/4.png",
    alt: "Partenaire 4",
  },
  {
    src: "/1.png",
    alt: "Partenaire 1",
  },
  {
    src: "/2.png", 
    alt: "Partenaire 2",
  },
  {
    src: "/3.png",
    alt: "Partenaire 3", 
  },
  {
    src: "/4.png",
    alt: "Partenaire 4",
  },
];